export default function (cumulative, logType, chart_id) {
  if (window["myCumulativeChart" + chart_id]) {
    window["myCumulativeChart" + chart_id].destroy();
  }

  let cumulative_unit = "";
  switch (logType) {
    case "day":
      cumulative_unit = "每小時電度";
      break;
    case "year":
      cumulative_unit = "每月電度";
      break;
    default:
      cumulative_unit = "每日電度";
      break;
  }

  let count = 1;
  let logConfig = {
    type: "bar",
    data: {
      labels: [],
      times: [],
      datasets: [
        {
          label: cumulative_unit,
          backgroundColor: ["rgba(75, 192, 192, 0.2)"],
          borderColor: ["rgb(75, 192, 192)"],
          borderWidth: 1,
          data: [],
          yAxisID: "y", // default
        },
        {
          label: "累計電度",
          tension: 0.1,
          backgroundColor: "rgba(187, 192, 42, 0.2)",
          borderColor: "rgb(187, 192, 42)",
          pointRadius: 2,
          pointBackgroundColor: "rgba(187, 192, 42, 0.2)",
          pointBorderColor: "rgb(187, 192, 42)",
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgb(187, 192, 42)",
          pointHitRadius: 50,
          pointBorderWidth: 2,
          data: [],
          type: "line",
          yAxisID: "line",
        },
      ],
    },
    options: {
      maintainAspectRatio: false,
      scales: {
        x: {
          display: true,
          stacked: true,
          title: {
            display: true,
          },
          ticks: {
            callback(value, index, values) {
              // 時間區間
              if (count <= 1 || (index % count) + 1 == 1) {
                return logConfig.data.labels[index];
              }
            },
          },
        },
        y: {
          position: "left",
          display: true,
          title: {
            display: true,
          },
          suggestedMin: 0,
          suggestedMax: 10,
        },
        line: {
          type: "linear",
          position: "right",
          grid: {
            display: false,
          },
          suggestedMin: 0,
          suggestedMax: 120,
          ticks: {
            callback: (value, values, ctx) => {
              return value.toFixed(2);
            },
          },
          display: true,
          title: {
            display: true,
            text: "累積電度",
          },
        },
      },
      plugins: {
        // 移到點上的提示框，顯示點的時間
        tooltip: {
          callbacks: {
            title(context) {
              return (
                logConfig.data.times[context[0].dataIndex] ??
                logConfig.data.labels[context[0].dataIndex]
              );
            },
            label(context) {
              return " " + context.raw + " " + "kwh";
            },
          },
        },
      },
    },
  };

  switch (logType) {
    case "year":
      logConfig.options.scales.x.title.text = "月份";
      count = 1;
      break;
    case "month":
      logConfig.options.scales.x.title.text = "日期";
      count = 3;
      break;
    case "week":
      logConfig.options.scales.x.title.text = "日期";
      count = 1;
      break;
    case "day":
      logConfig.options.scales.x.title.text = "時間";
      count = 2;
      break;
    default:
      logConfig.options.scales.x.title.text = "時間";
      count = 1;
      logConfig.data.times = data[0]["unit"];
      break;
  }

  if (!!cumulative) {
    logConfig.options.scales.y.title.text = "每小時電度(kWh)";
    cumulative.forEach((value) => {
      logConfig.data.labels.push(value.time);
      logConfig.data.times.push(value.unit ?? value.time);
      logConfig.data.datasets[0].data.push(value.kWh === "" ? null : value.kWh);
      logConfig.data.datasets[1].data.push(
        value.cumulative_ep === "" ? null : value.cumulative_ep
      );
    });
  }

  let ctx = document.getElementById(`cumulativeChart${chart_id}`);
  window["myCumulativeChart" + chart_id] = new Chart(ctx, logConfig);
}
